module.exports = __webpack_public_path__ + "img/weixin-share2.e5fb57a4.png";